/**
 * Размерная линия для иллюстраций главной: выносные линии, засечки под 45° и число
 * над линией — как на рабочем чертеже. Рисуется штрихом через класс `lp-draw`.
 */
interface Props {
	/** Начало и конец измеряемого отрезка (по оси x для горизонтальной, по y для вертикальной) */
	from: number;
	to: number;
	/** Где проходит сама размерная линия */
	at: number;
	/** Откуда начинаются выносные линии */
	base: number;
	vertical?: boolean;
	label: string;
	/** Задержка анимации, секунды */
	delay?: number;
	className?: string;
}

const TICK = 4;

export const DimensionLine = ({
	from,
	to,
	at,
	base,
	vertical = false,
	label,
	delay = 0,
	className = "",
}: Props) => {
	// Рисуем в горизонтальной системе, вертикальную получаем поворотом точек
	const point = (along: number, across: number) =>
		vertical ? `${across} ${along}` : `${along} ${across}`;
	const line = `M${point(from, at)}L${point(to, at)}`;
	const extensions = `M${point(from, base)}L${point(from, at)}M${point(to, base)}L${point(to, at)}`;
	const ticks = [from, to]
		.map((end) =>
			vertical
				? `M${at - TICK / 2} ${end + TICK / 2}L${at + TICK / 2} ${end - TICK / 2}`
				: `M${end - TICK / 2} ${at + TICK / 2}L${end + TICK / 2} ${at - TICK / 2}`,
		)
		.join("");
	const middle = (from + to) / 2;
	const style = { "--d": `${delay}s` } as React.CSSProperties;

	return (
		<g className={className}>
			<path className="lp-draw lp-dim-ext" d={extensions} pathLength={1} style={style} />
			<path className="lp-draw lp-dim" d={line + ticks} pathLength={1} style={style} />
			<text
				className="lp-fade lp-dim-text"
				style={{ "--d": `${delay + 0.4}s` } as React.CSSProperties}
				x={vertical ? at - 3 : middle}
				y={vertical ? middle : at - 3}
				transform={vertical ? `rotate(-90 ${at - 3} ${middle})` : undefined}
			>
				{label}
			</text>
		</g>
	);
};
